(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name commons.directive:toolbar
     * @restrict EA
     * @element
     *
     * @description
     *
     * @example
     <example module="commons">
     <file name="index.html">
     <toolbar></toolbar>
     </file>
     </example>
     *
     */
    angular
        .module('commons')
        .directive('toolbar', toolbar);

    function toolbar() {
        return {
            restrict: 'EA',
            scope: {
                view: "@",
                data: '=',
                status: '='
            },
            templateUrl: 'commons/directives/toolbar-directive.tpl.html',
            replace: false,
            controllerAs: 'toolbar',
            bindToController: true,
            controller: function ($scope, EventManagerService, ToolBarService, CommonMasterData, MessageService) {
                var vm = this;
                vm.isPublishedVisible = false; //Show/Hide publish button in crewing
                vm.refreshTime = [
                    {value: '0', name: 'OFF'},
                    {value: '3', name: '3 mins'},
                    {value: '5', name: '5 mins'},
                    {value: '10', name: '10 mins'},
                    {value: '15', name: '15 mins'}
                ];
                vm.selectedRefreshOption = 'OFF';
                vm.publishScheduleActive = false;
                vm.isFullScreen = false;
                vm.searchTimePeriod = "Month";
                vm.aeroOpsEnableParam = false;



                //slot message enable status
                isShowSlotMessage();
                getAeroOpsEnableParam();
                isAutoPairingEnabled();

                vm.tracking = {
                    isToolbarIconDisable: true
                };

                $scope.EventManagerService = EventManagerService;
                /* jshint unused:false */
                /* eslint "no-unused-vars": [2, {"args": "none"}] */

                EventManagerService.registerEventListener(EventManagerService.EVENT.CREWING.IS_CREW_SCHEDULE_PUBLISHED, crewSchedulePublishedHandler);
                EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CONFIG_CHANGED, configChanged);
                EventManagerService.registerEventListener(EventManagerService.EVENT.CREW_SCHEDULE.TYPE_CHANGE, crewingViewTypeChange);
                EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.SCREEN_MODE_CHANGE, changeScreenMode);
                EventManagerService.registerEventListener(EventManagerService.EVENT.TRACKING.TRACKING_FLIGTS_UPDATED, onTrackingSearchChange);

                vm.getToolBarSelectionByKey = function (key) {
                    return ToolBarService.getToolBarSelectionByKey(key);
                };

                vm.onClick = function (eventType, data, view) {
                  if (!!data) {
                    if (data.mode == "W") {
                      vm.searchTimePeriod = "Week"
                    } else if (data.mode == "D") {
                      vm.searchTimePeriod = "Day"
                    }else if (data.mode =="M"){
                      vm.searchTimePeriod = "Month"

                    }
                  }
                    EventManagerService.notifyEventListeners(eventType, data, view);
                };

              function getAeroOpsEnableParam(){
                CommonMasterData.getAeroOpsEnableParam(
                  function (aeroOpsEnableParam) {
                    if(angular.equals(aeroOpsEnableParam.paramValue,"Y")){
                      vm.aeroOpsEnableParam = true;
                    }else{
                      vm.aeroOpsEnableParam = false;
                    }

                  },
                  function () {
                    console.log('AeroOps Enable Param retrieval error');
                  }
                );
              }

                function onTrackingSearchChange(recordCount) {
                    vm.tracking.isToolbarIconDisable = (recordCount == 0);
                }

                function crewSchedulePublishedHandler(isPublished) {
                    vm.isPublishedVisible = !isPublished;
                }

                function configChanged() {
                    vm[vm.view] = ToolBarService.getButtonConfigsByView(vm.view);
                }

                vm.changeRefreshTime = function (action) {
                    vm.selectedRefreshOption = action.name;
                };
                function crewingViewTypeChange() {
                    vm.publishScheduleActive = false;
                }

                function changeScreenMode(mode) {
                    vm.isFullScreen = mode;
                }

                vm.changeViewMode = function () {
                    vm.isFullScreen = !vm.isFullScreen
                };

                function isShowSlotMessage() {
                  CommonMasterData.isShowSlotMessage(function(response) {
                    vm.isShowSlotMessage = response;
                  }, function(error) {
                    MessageService.error(error);
                  });
                }
              function isAutoPairingEnabled() {
                CommonMasterData.isAutoPairingEnabled(function(response) {
                  vm.isAutoPairingEnabled = response;
                }, function(error) {
                  MessageService.error(error);
                });
              }
            },
            link: function (scope, element, attrs) {
            }
        };
    }
}());
